// import { useState } from 'react';

import { faChartSimple, faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useRef } from "react";
import { BsPersonFillCheck } from "react-icons/bs";
import { ObserverContext } from "../../Contexts/ObserverContext";
// import OwlCarousel from "react-owl-carousel";
// import "owl.carousel/dist/assets/owl.carousel.css";
// import "owl.carousel/dist/assets/owl.theme.default.css";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { Link } from "react-router-dom";
import risl from "../../assets/risl.jpg";
import interwood from "../../assets/interwood.jpg";
import yhmc from "../../assets/yhmc.jpg";
import cab from "../../assets/cab.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

function Startcounter() {
  const carouselRef = useRef(null); // 🔑 Ref for OwlCarousel

  const sliderNext = () => {
    if (carouselRef.current) {
      carouselRef.current.next(); // ✅ safe call
    }
  };

  const sliderPrev = () => {
    if (carouselRef.current) {
      carouselRef.current.prev(); // ✅ safe call
    }
  };

  const ref = useRef();
  const { activeSection, setActiveSection } = useContext(ObserverContext);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setActiveSection("accomplishments");
        console.log("this is updated section", activeSection);
      }
    });
    if (ref && ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      observer.disconnect();
    };
  }, [ref]);

  return (
    <section className="counter-section" id="accomplishments" ref={ref}>
      <div className="container">
        <h1
          className="wow fadeInDown"
          data-wow-delay="300ms"
          style={{
            visibility: "hidden",
            animationDelay: "300ms",
            animationName: "none",
            textAlign: "center",
          }}
        >
          Our Success Stories & Accomplishments
        </h1>
        <p
          className="wow fadeInDown"
          data-wow-delay="300ms"
          style={{
            visibility: "hidden",
            animationDelay: "300ms",
            animationName: "none",
          }}
        >
          Fostering Relationships while moving Forward on our success Trajectory
        </p>
        <div className="row no-gutters">
          {/* Counter-1 */}
          <div
            className="col-lg-4 col-md-12 col-sm-12 col-xs-12 wow fadeInLeft"
            data-wow-delay="400ms"
            style={{
              visibility: "hidden",
              animationDelay: "400ms",
              animationName: "none",
            }}
          >
            <div className="counter">
              <div className="media">
                <FontAwesomeIcon icon={faUser} size="2xl" />
                <div className="media-body mt-4 mt-md-0">
                  <span className="timer count-title count-number count">
                    150+
                  </span>
                  <p>Clients Served</p>
                </div>
              </div>
            </div>
          </div>

          {/* Counter-2 */}
          <div
            className="col-lg-4 col-md-12 col-sm-12 col-xs-12 wow fadeInLeft"
            data-wow-delay="400ms"
            style={{
              visibility: "hidden",
              animationDelay: "400ms",
              animationName: "none",
            }}
          >
            <div className="counter">
              <div className="media">
                <FontAwesomeIcon icon={faChartSimple} size="2xl" />
                <div className="media-body mt-4 mt-md-0">
                  <span className="timer count-title count-number count">
                    200+
                  </span>
                  <p>Projects Done</p>
                </div>
              </div>
            </div>
          </div>

          {/* Counter-3 */}
          <div
            className="col-lg-4 col-md-12 col-sm-12 col-xs-12 wow fadeInRight"
            data-wow-delay="400ms"
            style={{
              visibility: "hidden",
              animationDelay: "400ms",
              animationName: "none",
            }}
          >
            <div className="counter">
              <div className="media">
                <BsPersonFillCheck
                  style={{ fontSize: "30px", color: "black" }}
                />
                <div className="media-body mt-4 mt-md-0">
                  <span className="timer count-title count-number count">
                    50+
                  </span>
                  <p>Industry Experts</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h1
        className="wow fadeInDown"
        data-wow-delay="300ms"
        style={{
          visibility: "hidden",
          animationDelay: "300ms",
          animationName: "none",
          textAlign: "center",
        }}
      >
        Our Accomplishments in Enterprise IT & ERP Solutions
      </h1>
      <p className="wow fadeInDown" data-wow-delay="300ms">
        Over the past three decades, Access Infotech Pvt. Ltd. has successfully
        delivered enterprise technology solutions across defence, healthcare,
        manufacturing, and pharmaceuticals. Our accomplishments demonstrate our
        ability to combine innovation, security, and scalability—helping
        organizations transform digitally while ensuring compliance and
        operational efficiency.
      </p>
      <h2
        className="wow fadeInDown"
        data-wow-delay="300ms"
        style={{
          visibility: "hidden",
          animationDelay: "300ms",
          animationName: "none",
          textAlign: "center",
        }}
      >
        Defence and Government Projects
      </h2>
      <h5
        className="wow fadeInDown"
        data-wow-delay="300ms"
        style={{ textAlign: "center" }}
      >
        Computerisation of Pension for Defence Services
      </h5>
      <p className="wow fadeInDown" data-wow-delay="300ms">
        We developed a secure pension management system for defence services,
        enabling automated disbursement, real-time tracking, and accurate
        record-keeping for lakhs of veterans.
      </p>
      <h5
        className="wow fadeInDown"
        data-wow-delay="300ms"
        style={{ textAlign: "center" }}
      >
        Computerisation of Pension for Air Veterans
      </h5>
      <p className="wow fadeInDown" data-wow-delay="300ms">
        Our dedicated ERP solution modernized pension management for air force
        veterans, ensuring timely updates, error-free calculations, and seamless
        integration with central government systems.
      </p>
      <h2
        className="wow fadeInDown"
        data-wow-delay="300ms"
        style={{
          visibility: "hidden",
          animationDelay: "300ms",
          animationName: "none",
          textAlign: "center",
        }}
      >
        Enterprise Solutions
      </h2>
      <h5
        className="wow fadeInDown"
        data-wow-delay="300ms"
        style={{ textAlign: "center" }}
      >
        Inventory Management System (IMS)
      </h5>
      <p className="wow fadeInDown" data-wow-delay="300ms">
        Designed a robust IMS to streamline stock monitoring, procurement, and
        reporting. The system helps organizations reduce losses, improve
        visibility, and optimize warehouse operations.
      </p>
      <h5
        className="wow fadeInDown"
        data-wow-delay="300ms"
        style={{ textAlign: "center" }}
      >
        ERP Solution on Mobile
      </h5>
      <p className="wow fadeInDown" data-wow-delay="300ms">
        Delivered a mobile-first ERP platform for enterprises seeking agility.
        Employees and managers can now track, approve, and manage operations on
        the go with full data security.
      </p>
      <h5
        className="wow fadeInDown"
        data-wow-delay="300ms"
        style={{ textAlign: "center" }}
      >
        ERP Solution for Pharmaceutical Company
      </h5>
      <p className="wow fadeInDown" data-wow-delay="300ms">
        Built a custom ERP solution tailored to the pharma industry, ensuring
        compliance with regulatory standards, maintaining batch traceability,
        and improving supply chain efficiency.
      </p>
       <h2
        className="wow fadeInDown"
        data-wow-delay="300ms"
        style={{
          visibility: "hidden",
          animationDelay: "300ms",
          animationName: "none",
          textAlign: "center",
        }}
      >
        Recognition & Client Success
      </h2>
       <ul className="wow fadeInDown" data-wow-delay="300ms" style={{textAlign:"center"}}>
  <li>Successfully implemented database administration services for leading enterprises.</li>
  <li>Delivered custom application development projects across industries.</li>
  <li>Trusted by a growing base of esteemed clients in India and abroad.</li>
</ul>

      {/* Success Stories Carousel */}
      <div>
        <h2
          className="wow fadeInDown"
          data-wow-delay="300ms"
          style={{
            visibility: "hidden",
            animationDelay: "300ms",
            animationName: "none",
            textAlign: "center",
          }}
        >
          Client Success Stories
        </h2>
        {/* <h2
          className="wow bounceInLeft mobile-font-size corausel-text-2 mb-3"
          data-wow-delay="300ms"
          style={{ color: 'black', textAlign: 'center', paddingBottom: '40px' }}
        >
          Client Success Stories
        </h2> */}
        <div
          className="position-relative"
          style={{ position: "relative", display: "flex" }}
        >
          {/* Left arrow */}
          <div className="position-absolute h-100 left-0 top-0 d-flex align-items-center px-2 z-2">
            <div
              onClick={sliderPrev}
              className="carousel-nav-btn d-flex justify-content-center align-items-center"
            >
              <BsChevronLeft color="#fff" size={15} />
            </div>
          </div>

          {/* Right arrow */}
          <div className="position-absolute h-100 right-0 top-0 d-flex align-items-center px-2 z-2">
            <div
              onClick={sliderNext}
              className="carousel-nav-btn d-flex justify-content-center align-items-center"
            >
              <BsChevronRight color="#fff" size={15} />
            </div>
          </div>
<Swiper
  modules={[Navigation, Autoplay]}
  slidesPerView={1}
  loop={true}
  autoplay={{ delay: 4000 }}
>

          {/* Carousel */}
          {/* <OwlCarousel
            ref={carouselRef} // 🔑 attach ref here
            items={1}
            className="owl-theme"
            loop
            nav={false}
            dots={false}
            autoplay={true}
          > */}
            <div className="success-story-slide item position-relative">
              <div className="container h-100 d-flex flex-column justify-content-center align-items-center">
                <img
                  src={yhmc}
                  style={{
                    height: "120px",
                    width: "350px",
                    marginBottom: "30px",
                    borderRadius: "8px",
                  }}
                />
                <p
                  className="success-slider-inner-txt"
                  style={{ color: "white" }}
                >
                  In such a global competition era, ERP has become the focus of
                  corporate operations and management. Such ERP systems does not
                  only tackle information technology issues but they are real
                  time business problem solver i.e related to production, sales,
                  purchase, inventory human resource, enterprice culture and
                  organizational restructuring and so on
                </p>
              </div>
            </div>

            <div className="success-story-slide item position-relative">
              <div className="container h-100 d-flex flex-column justify-content-center align-items-center">
                <img
                  src={cab}
                  style={{
                    height: "120px",
                    width: "350px",
                    marginBottom: "30px",
                    borderRadius: "8px",
                  }}
                />
                <p
                  className="success-slider-inner-txt"
                  style={{ color: "white" }}
                >
                  The Comptroller and Auditor General of India discharge his
                  multifarious duties through the Indian Audits and Accounts
                  Department. The Department Consists of about fifty thousand
                  employees and is functionally organized into 133 specialized
                  formations throughout the country.
                </p>
              </div>
            </div>

            <div className="success-story-slide item position-relative">
              <div className="container h-100 d-flex flex-column justify-content-center align-items-center">
                <img
                  src={interwood}
                  style={{
                    height: "120px",
                    width: "350px",
                    marginBottom: "30px",
                    borderRadius: "8px",
                  }}
                />
                <p
                  className="success-slider-inner-txt"
                  style={{ color: "white" }}
                >
                  Enabled INTER WOOD Mobel to achieve an exponential business
                  growth. Align its sales processes as per industry standards.
                  Track site work efficiency increase customer satisfaction.
                  Ensure uniform Pricing across its sales outlets and dealers.
                </p>
              </div>
            </div>

            <div className="success-story-slide item position-relative">
              <div className="container h-100 d-flex flex-column justify-content-center align-items-center">
                <img
                  src={risl}
                  style={{
                    height: "120px",
                    width: "450px",
                    marginBottom: "30px",
                    borderRadius: "8px",
                  }}
                />
                <p
                  className="success-slider-inner-txt"
                  style={{ color: "white" }}
                >
                  Development and Integration of FMS with Accountant General’s
                  VLC application for Government of Rajasthan
                </p>
              </div>
            </div>
          {/* </OwlCarousel> */}
          </Swiper>
        </div>
      </div>
    </section>
  );
}

export default Startcounter;
